/* eslint-disable camelcase */
import type { ChartData, ChartOptions } from 'chart.js';
import moment from 'moment';
import React, { useState, useEffect } from 'react';

import { Line } from 'react-chartjs-2';

import swal from 'sweetalert';

import Loader from '../../../../elements/Loader';

interface Props {
    title: string;
    axiosRequestCallback: (formattedStartDate: string, formattedEndDate: string) => Promise<any>;
    numberOfWeeks: number;
    label: string;
}

export default function LinearBlock({ title, axiosRequestCallback, numberOfWeeks, label }: Props) {
    const [values, setValues] = useState<Array<number>>([]);
    const [isLoading, setIsLoading] = useState<Boolean>(true);

    const startDate = moment().subtract(numberOfWeeks, 'weeks');
    const endDate = moment().endOf('week');

    function triggerUpdate() {
        const formattedStartDate = startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const formattedEndDate = endDate?.endOf('day').format('YYYY-MM-DD HH:mm:ss');

        setIsLoading(true);
        axiosRequestCallback(formattedStartDate, formattedEndDate)
            .then((response) => {
                setValues(response.data);
            })
            .catch(() => {
                swal({
                    title: 'Error',
                    text: 'We have encountred an error.',
                    icon: 'error',
                });
            });
        setIsLoading(false);
    }

    useEffect(() => {
        triggerUpdate();
    }, []);

    function getLineChart() {
        const getLastWeeks = () => {
            const weeks = [];
            const today = new Date();
            for (let i = numberOfWeeks - 1; i >= 0; i--) {
                const date = new Date(today);
                date.setDate(date.getDate() - i * (numberOfWeeks - 1));
                weeks.push(date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }));
            }
            return weeks;
        };

        const data: ChartData = {
            labels: getLastWeeks(), // X-axis labels
            datasets: [
                {
                    label,
                    data: values,
                    borderColor: 'rgb(255,192,14)',
                    fill: false,
                    pointBackgroundColor: 'rgb(255,192,14)',
                    pointBorderWidth: 2,
                    pointStyle: 'circle',
                    pointRadius: 10,
                    pointHoverRadius: 15,
                },
            ],
        };

        const options: ChartOptions = {
            responsive: true,
            legend: {
                display: false,
            },
            scales: {
                yAxes: [
                    {
                        ticks: {
                            fontColor: 'white',
                        },
                    },
                ],
                xAxes: [
                    {
                        ticks: {
                            fontColor: 'white',
                        },
                    },
                ],
            },
        };

        return <Line data={data} options={options} />;
    }

    const getContent = () => {
        return (
            <div className="dashboard-block">
                <div className="dashboard-block-header">
                    <div className="dashboard-block-header-title">{title}</div>
                </div>
                <div className="dashboard-block-data">{getLineChart()}</div>
            </div>
        );
    };
    return <Loader loading={isLoading} content={getContent} />;
}
